import { IRoom } from "@/models/room/Room";
import { useEffect, useState } from "react";
import RoomService from "../services/room/RoomService";

const useRoomByPic = (initial: string | undefined) => {
  const [rooms, setRooms] = useState<IRoom[]>([]);
  const [status, setStatus] = useState<string>("");

  useEffect(() => {
    let ignore = false;
    const fetchData = async (ignore: boolean) => {
      if (!initial || initial === "") {
        return;
      }

      setStatus("loading");
      const rooms = await RoomService.getRoomByBorrowingPic(initial);
      if (ignore) {
        setStatus("success");
        return;
      }

      if (rooms && rooms.length > 0) {
        setStatus("success");
        setRooms(rooms);
      } else {
        setStatus("error");
      }
    };

    fetchData(ignore);
    return () => {
      ignore = true;
    };
  }, [initial]);

  return { rooms, status };
};

export default useRoomByPic;
